import { createSelector } from 'reselect';
import { getActivities, getActivitiesWithoutFieldNotes } from './scoutingSelectorsNew';
import { ShapeType } from '../types/Common';

const regionActivityTypes: ShapeType[] = [
  ShapeType.POLYGON,
  ShapeType.MULTI_POLYGON,
];

export const getFieldNotesActivities = createSelector(
  [getActivities],
  (activities) => activities.filter((activity) => !activity.location)
);

export const getRegions = createSelector(
  [getActivitiesWithoutFieldNotes],
  (activities) => activities.filter(
      (activity) => activity.location && activity.location.type && regionActivityTypes.includes(activity.location.type)
    )
);

/**
 * Returns only scouting pins activities
 * @param {Array} activities
 * @return {Array}
 */
export const getPinsActivities = createSelector(
  [getActivitiesWithoutFieldNotes],
  (activities) => activities.filter(
      (activity) => activity.location && activity.location.type && activity.location.type === ShapeType.POINT
    )
);
